import { getApiService } from '@/services/api';
import { ApiResponse } from '@/services/api/types';
import { ContactLinkCategory } from '../model/contactLinkCategory.ts';

const CONTACT_LINK_CATEGORIES_PATH = '/contact-link-category';

export class ContactLinkCategoriesApi {
  private static getApiInstance() {
    return getApiService();
  }

  static async getAll(): Promise<ApiResponse<ContactLinkCategory[]>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get<ContactLinkCategory[]>(CONTACT_LINK_CATEGORIES_PATH);
  }

  static async getById(id: string): Promise<ApiResponse<ContactLinkCategory>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get<ContactLinkCategory>(`${CONTACT_LINK_CATEGORIES_PATH}/${id}`);
  }

  static async create(data: Omit<ContactLinkCategory, 'id'>) {
    const apiService = this.getApiInstance();
    return await apiService.client.post(CONTACT_LINK_CATEGORIES_PATH, data);
  }

  static async update(id: string, data: Omit<ContactLinkCategory, 'id'>) {
    const apiService = this.getApiInstance();
    return await apiService.client.put(`${CONTACT_LINK_CATEGORIES_PATH}/${id}`, data);
  }

  static async delete(id: string) {
    const apiService = this.getApiInstance();
    return await apiService.client.delete(`${CONTACT_LINK_CATEGORIES_PATH}/${id}`);
  }
}
